angular.module('wbDashboard').controller('PlansDetailFeatureFlexibleautodepositsControllerAurea', ['$scope', '$q', '$timeout', 'PlanService', 'User', 'Message', function ($scope, $q, $timeout, PlanService, User, Message) {
    /*jshint -W030 */
    $scope.localData || ($scope.localData = {});
    /*jshint +W030 */
    $scope.localData.autos = {};
    $scope.localData.frequencies = PlanService.info.fastmoney.flexibleautodeposits.frequencies;

    $scope.updateAutoDeposit = function() {
        $scope.pageData.sending = true;

        if ($scope.localData.autos.frequency_dates) {
            $scope.localData.autos.frequency_dates.sort(function (a, b) { return a - b; });
        }
        PlanService.user.updateAutos({
            frequency: $scope.localData.autos.frequency,
            frequency_dates: $scope.localData.autos.frequency_dates,
            frequency_weekday: $scope.localData.autos.frequency_weekday,
            frequency_start_date: $scope.localData.autos.frequency_start_date
        }).then(function() {
            User.retrieveActivityPending(true);
            return $q.all([PlanService.user.retrieveAutos(), User.retrieveAllMilestones(true)]);
        }).then(function() {
            $scope.finishEdit();
            Message.set({
                text: "Successfully updated auto-deposit info!",
                type: "success"
            });
        }).catch(function() {
            Message.set({
                text:"Something went wrong, please try again. If you continue to have problems, please email support@axosinvest.com.",
                type: "danger"
            });
        }).finally(function() {
            $scope.pageData.sending = false;
        });

    };

    $scope.disableFlexibleAutoDeposits = function(frequency) {
        var data;
        switch (frequency) {
            case "Weekly":
                data = {
                    frequency: "Weekly",
                    frequency_weekday: "Monday"
                };
                break;
            case "Monthly":
                data = {
                    frequency: "Monthly",
                    frequency_dates: [1]
                };
                break;
        }
        $scope.pageData.sending = true;
        PlanService.user.updateAutos(data).then(function() {
            return $q.all([PlanService.user.retrieveAutos(), User.retrieveAllMilestones(true)]);
        }).then(function() {
            if (!$scope.disablingPlan) {
                return $scope.toggleFeature($scope.feature);
            }
        }).then(function() {
            //need the finish to finish after retrieveAutos change listeners do
            $timeout(function() {
                $scope.finishEdit();
            });
        }).catch(function() {
            Message.set({
                text:"Something went wrong, please try again. If you continue to have problems, please email support@axosinvest.com.",
                type: "danger"
            });
        }).finally(function() {
            $scope.pageData.sending = false;
        });

    };

    $scope.$watch('overview', function(overview) {
        if (overview) {
        }
    });
    $scope.$watch('autos', function(autos) {
        if (autos) {
            angular.copy(autos, $scope.localData.autos);
        }
    });

    $scope.toggleFeature.onMessage = "You now have full control over your auto-deposits.";
    $scope.toggleFeature.offMessage = "You can turn this back on at any time.";

    if ($scope.$state.current.name.indexOf('edit') > -1) {
        if (!$scope.$stateParams.page || ['frequency','day','disable'].indexOf($scope.$stateParams.page) === -1) {
            //if no page, or page is invalid
            $scope.$state.go(".", {page:'frequency'}, {location: "replace"});
        } else if ($scope.$stateParams.page === 'day') {
            //if page is loaded from edit screen, always go to parent
            $scope.$state.go("^", {}, {location: "replace"});
        }
    }

    var transitionDeregisterHook = $scope.$transitions.onStart({ to: "base.plans.detail.plan.feature.detail.edit" }, function(trans) {
    });
    $scope.$on('$destroy', function() {
        if (transitionDeregisterHook) {
            transitionDeregisterHook();
        }
    });

}]);
